// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LiWF","content":"_3eWLN"};